export enum ProductionParkComponentType {
  SOLAR_PANEL = "SOLAR_PANEL",
  WIND_GENERATOR = "WIND_GENERATOR",
  INVERTER = "INVERTER",
  NETWORK = "NETWORK",
}
